import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from './TableHead.module.scss';

const TableHead = forwardRef(({ className, ...props }, ref) => {
  return <thead {...props} ref={ref} className={cn(styles.root, className)} />;
});

export default TableHead;
